import { useRef, useState } from 'react';
import '../assets/styles/Contact.scss';
import emailjs from '@emailjs/browser';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import SendIcon from '@mui/icons-material/Send';
import TextField from '@mui/material/TextField';


function Contact() {

  emailjs.init({ publicKey: 'ZbuZN4p75CmxnifOu' });

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  const [nameError, setNameError] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [messageError, setMessageError] = useState(false);

  const form = useRef();

  const sendEmail = async (e) => {

    e.preventDefault();
    try {

      setNameError(name === '');
      setEmailError(email === '');
      setMessageError(message === '');

      /* Uncomment below if you want to enable the emailJS */

      if (name !== '' && email !== '' && message !== '') {
        const templateParams = {
          name: name,
          email: email,
          message: message
        };


        const result = await emailjs.send('service_vbhjdoi', 'template_75ronxd', templateParams)
        if (result.status !== 200) {
          console.log(result)
          return alert('An error occurred while sending your message. Please try again later.');
        }
        alert('Message sent successfully!', 'success');

        setName('');
        setEmail('');
        setMessage('');
      }
    }
    catch (error) {
      console.error('Error sending email:', error);
      alert('An error occurred while sending your message. Please try again later.', 'error');
    }

  };

  return (
    <div id="contact">
      <div className="items-container">
        <div className="contact_wrapper">
          <h1>Contact Me</h1>
          <p>Got a project waiting to be realized? Let's collaborate and make it happen!</p>
          <Box
            ref={form}
            component="form"
            noValidate
            autoComplete="off"
            className='contact-form'
          >
            <div className='form-flex'>
              <TextField
                required
                id="outlined-required"
                label="Your Name"
                placeholder="What's your name?"
                value={name}
                name='name'
                onChange={(e) => {
                  setName(e.target.value);
                }}
                error={nameError}
                helperText={nameError ? "Please enter your name" : ""}
              />
              <TextField
                required
                id="outlined-required"
                label="Email / Phone"
                name='email'
                type='email'
                placeholder="How can I reach you?"
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                }}
                error={emailError}
                helperText={emailError ? "Please enter your email or phone number" : ""}
              />
            </div>
            <TextField
              required
              id="outlined-multiline-static"
              label="Message"
              placeholder="Send me any inquiries or questions"
              multiline
              rows={10}
              className="body-form"
              value={message}
              onChange={(e) => {
                setMessage(e.target.value);
              }}
              error={messageError}
              helperText={messageError ? "Please enter the message" : ""}
            />
            <Button variant="contained" endIcon={<SendIcon />} onClick={sendEmail}>
              Send
            </Button>
          </Box>
        </div>
      </div>
    </div>
  );
}

export default Contact;